/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID ?? '2cb909a7-7914-4e06-a17f-fbce60f07679',
    authority: `https://login.microsoftonline.com/${
      process.env.REACT_APP_TENANT_ID ?? 'd6f59afa-ec59-4708-b9c4-d57f51584833'
    }`,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI ?? 'http://localhost:3000/',
  },
  cache: {
    // cacheLocation: 'localStorage', // Ensure tokens persist across reloads
    // storeAuthStateInCookie: true, // Use this for older browsers
    // VAPT-001: keep the MSAL cache out of persistent, script-readable localStorage.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  // cache: {
  //   cacheLocation: 'localStorage', // Default is "sessionStorage"
  //   storeAuthStateInCookie: true, // For IE11 or Edge
  // },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read'],
  prompt: 'select_account',
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me', //e.g. https://graph.microsoft.com/v1.0/me
};
